import { render, staticRenderFns } from "./InvitedConversationDescription.vue?vue&type=template&id=433bdcbd&scoped=true"
import script from "./InvitedConversationDescription.vue?vue&type=script&lang=js"
export * from "./InvitedConversationDescription.vue?vue&type=script&lang=js"
import style0 from "./InvitedConversationDescription.vue?vue&type=style&index=0&id=433bdcbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bdcbd",
  null
  
)

export default component.exports